export const fields = () => ({
  startDate: {
    label: '開始日',
    type: 'date',
    validations: {
      required: _ => _ != null,
    },
  },
  endDate: {
    label: '終了日',
    type: 'date',
    validations: {
      required: _ => _ != null,
    },
  },
  description: {
    label: '説明',
    type: 'text',
  },
});